module.exports = __webpack_public_path__ + "static/media/satellite.41f10dff.svg";